const GetLaboratoriesNames = (id) =>
  ({
    0: { name: "Register" },
    1: { name: "CMS Brisbane" },
    2: { name: "CMS Perth" },
    3: { name: "CMS Newcastle" },
  }[id]);
export default GetLaboratoriesNames;
